import { BillingSettlePaymentStore } from './bill.settlePayment.api';

export class BillStore {
  public settlePayment = new BillingSettlePaymentStore();
}

const billStore = new BillStore();
export default billStore;
